import { notify } from "@/lib/notify";

// PATCH 36 Me15 — optimistic UI for low-risk actions. Apply the new state instantly, fire the
// request, and on a GENUINE failure roll the UI back visibly so it never shows a state that
// didn't actually happen. Use only for cheap, reversible toggles/dismissals — never for money.
export async function optimistic({ apply, rollback, request, errorMessage }) {
  apply();
  try {
    return await request();
  } catch (e) {
    rollback();
    notify.error(errorMessage || "That didn't save — we've put it back the way it was.");
    return null;
  }
}
